module.exports = __webpack_public_path__ + "img/deyu.b2b693b8.png";